export default __webpack_public_path__ + "static/media/astro-scene_4.c15a308f.jpeg";